/**
 * API de usuarios y roles
 */
import client from './client';

export const usersApi = {
  list: (params = {}) =>
    client.get('/users', { params }),

  get: (userId) =>
    client.get(`/users/${userId}`),

  create: (data) =>
    client.post('/users', data),

  update: (userId, data) =>
    client.put(`/users/${userId}`, data),

  delete: (userId) =>
    client.delete(`/users/${userId}`),

  getMe: () =>
    client.get('/users/me'),

  updateMe: (data) =>
    client.put('/users/me', data),

  // Roles
  assignRole: (userId, roleName) =>
    client.post(`/users/${userId}/roles`, { role_name: roleName }),

  removeRole: (userId, roleName) =>
    client.delete(`/users/${userId}/roles/${roleName}`),

  listRoles: () =>
    client.get('/users/roles/all'),
};
